import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FcmRegistrationService {
  constructor(private http: HttpClient) {}

  // Uwaga: ten serwis sam dokłada "Bearer " – AuthService ma swój JWT bez Bearer
  registerToken(jwt: string, token: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + jwt
    });
    return this.http.post(environment.api + '/api/pharma/fcm/token', {
      token: token,
      userAgent: window.navigator.userAgent
    }, { headers: headers });
  }

  unregisterToken(jwt: string, token: string) {
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + jwt });
    return this.http.delete(environment.api + '/api/fcm/token/' + encodeURIComponent(token), { headers: headers });
  }
}
